// import Icon from '@ant-design/icons';
import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import { Button, Menu, Modal } from "antd";
import "./sidebar.css";
import { MenuUnfoldOutlined, MenuFoldOutlined, HeartOutlined, HeartFilled } from "@ant-design/icons";
import { useSelector, useDispatch } from "react-redux";
import { useHistory } from "react-router-dom";
import ZenModal from "../../ZenModal";
import liracrypt from "../../Liracrypt/liracrypt";
import ApiErrorComp from "../../ApiErrorComp/ApiErrorComp";


const Sidebar = (props) => {
  const dispatchMenu = useDispatch();
  const urlCode = useSelector(state => state.urlCode);
  const [newMenus, setNewMenus] = useState([]);

  const menuList = useSelector((state) => state.menuList);
  // const menuList = JSON.parse(localStorage.getItem("side"))["menu"];
  const history = useHistory();
  const dispatch = useDispatch();
  const [modal, setModal] = useState({
    show: false,
    loading: false,
    data: null,
    typ: ''
  });


  const favMenu = (menu) => {
    liracrypt.patch('/test', { ...menu, isFav: !menu.isFav })
      .then(response => {
        console.log(response);
      }).catch(err => {
        console.log(err);
      })
  }

  const hideFavIcon = (id) => {
    document.getElementById(id).style.display = 'none';
  }

  const showFavIcon = (id) => {
    //  document.getElementById(id).style.removeProperty('display')
  }

  useEffect(() => {
    let menus = [];
    menuList.forEach((element, elementIndx) => {
      let subMenu = [];
      if (element.children) {
        element.children.forEach((x, xIndx) => {
          let subMenuElement = {
            label: <div
              onMouseEnter={() => showFavIcon(`x-fav-btn-${xIndx + elementIndx}`)}
              onMouseLeave={() => hideFavIcon(`x-fav-btn-${xIndx + elementIndx}`)}
              style={{ ...x.style, wordBreak: 'break-word', whiteSpace: 'normal', lineHeight: 'normal', display: 'flex', justifyContent: 'space-between' }} className="lira-sub-menu-label">
              <span>{x.label}</span>
              {
                !x.children?.length ?
                  <Button
                    id={`x-fav-btn-${xIndx + elementIndx}`}
                    onClick={(e) => { e.stopPropagation(); alert(1); }} type="link" style={{ display: 'none', marginRight: 10 }} ghost={true} icon={<HeartOutlined />}>{''}</Button> : null
              }
            </div >,
            key: x.key,
            link: x.link,
            disabled: x.disabled,
            icon: <i className={`fa ${x.icon}`} />
          }
          if (x.children) {
            let childSubMenu = [];
            x.children.forEach((y, yIndx) => {
              childSubMenu.push({
                label: <div
                  onMouseEnter={() => showFavIcon(`y-fav-btn-${yIndx + xIndx + elementIndx}`)}
                  onMouseLeave={() => hideFavIcon(`y-fav-btn-${yIndx + xIndx + elementIndx}`)}
                  style={{ ...y.style, wordBreak: 'break-word', whiteSpace: 'normal', lineHeight: 'normal', display: 'flex', justifyContent: 'space-between' }} className="lira-sub-menu-label">
                  <span>{y.label}</span>
                  <Button id={`y-fav-btn${yIndx + xIndx + elementIndx}`} onClick={(e) => { e.stopPropagation(); alert(1); }} type="link" style={{ display: 'none', marginRight: 10 }} ghost={true} icon={<HeartFilled />}>{''}</Button> : null
                </div>,
                key: y.key,
                link: y.link,
                disabled: y.disabled,
                icon: <i className={`fa ${y.icon}`} />
              })
            })
            subMenuElement.children = childSubMenu
          }
          subMenu.push(subMenuElement);
        })
      }
      menus.push({
        label: <div
          onMouseEnter={!subMenu.length ? () => showFavIcon(`elem-fav-btn-${elementIndx}`) : () => { }}
          onMouseLeave={!subMenu.length ? () => hideFavIcon(`elem-fav-btn-${elementIndx}`) : () => { }}
          style={{ ...element.style, wordBreak: 'break-word', whiteSpace: 'normal', lineHeight: 'normal', display: 'flex', justifyContent: 'space-between' }} className="lira-sub-menu-label">
          <span>{element.label}</span>
          {
            !subMenu.length ?
              <Button id={`elem-fav-btn-${elementIndx}`} onClick={(e) => { e.stopPropagation(); alert(1); }} type="link" style={{ display: 'none', marginRight: 10 }} ghost={true} icon={<HeartFilled />}>{''}</Button> : null
          }
        </div>,
        key: element.key,
        link: element.link,
        children: subMenu.length ? subMenu : null,
        disabled: element.disabled,
        icon: <i className={`fa ${element.icon}`} />
      });
    });
    setNewMenus(menus)
  }, []);


  function setMenuList(menus) {
    dispatch({ type: "SET_SIDEBAR", payload: menus });
  }

  const [collapsed, setCollapsed] = useState(
    props.collapsed ? props.collapsed : false
  );

  const toggle = () => {
    setCollapsed(!collapsed);
  };

  useEffect(() => {
    dispatchMenu({
      type: 'toggleMenu',
      payload: collapsed
    })
  }, [collapsed]);

  const toggleModal = ({ show = false, data = undefined, type = '', loading = false }) => {
    setModal({ show, data, type, loading });
  }

  const openLink = (item) => {
    if (item.popup?.visible) {
      Modal.warning({
        title: <h6
          style={{
            color: "#fff",
            margin: 0,
            fontWeight: 500,
            fontSize: "1rem",
          }}
        >
          {item.popup?.msg || "Please upgrade your plan to open this link"}
        </h6>,
        okText: "OK",
        centered: true,
      });
      return;
    };
    toggle();
    history.push(`/v02/${urlCode}` + item.link);
  }

  const navigateToLink = (key) => {
    let mainMenuKey = key.split("_")[0];
    let selectedMenu = menuList.find(x => x.key === mainMenuKey);
    if (selectedMenu.children) {
      let selectedChild = selectedMenu.children.find(x => x.key === key);
      openLink(selectedChild);
    } else {
      openLink(selectedMenu);
    }
  }

  const selectedKeys = window.location.pathname;
  const defaultOpenKeys = selectedKeys;

  if (menuList) {
    return (
      <div style={{ backgroundColor: '#262626' }}>
        <div
          className="sidebarLogo"
          style={{ display: 'inline-flex', width: '100%', justifyContent: 'space-around' }}
        >
          <span
            style={{
              display: collapsed ? "none" : "inline",
              padding: "1rem",
            }}
          >
            <img
              src={require('../../../assets/static/Df.png')}
              alt="logo.png"
              width="110px"
              height="50px"
            />
          </span>

          {React.createElement(
            collapsed ? MenuUnfoldOutlined : MenuFoldOutlined,
            {
              className: collapsed ? "triggerCollaped" : "trigger",
              onClick: toggle,
            }
          )}
        </div>
        <Menu
          onClick={({ key }) => navigateToLink(key)}
          defaultOpenKeys={[defaultOpenKeys]}
          selectedKeys={[selectedKeys]}
          mode="inline"
          theme="dark"
          inlineCollapsed={collapsed}
          items={newMenus}
        />
        <ZenModal modal={modal} toggleModal={toggleModal} zenModal={{
          width: '50%'
        }} />
      </div>
    );
  } else {
    return <></>;
  }
};

export default React.memo(Sidebar);
